var _rect, _path, _path2, _g, _g2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#E0F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30 L800 30",
    stroke: "#26A69A",
    strokeWidth: 2,
    strokeDasharray: "6 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 170 L800 170",
    stroke: "#26A69A",
    strokeWidth: 2,
    strokeDasharray: "6 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -25,
    width: 50,
    height: 50,
    fill: "#26A69A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -5,
    width: 60,
    height: 10,
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -30,
    width: 10,
    height: 60,
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -5,
    cy: -5,
    r: 8,
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: -5,
    r: 8,
    fill: "#FF5252"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(720, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -25,
    width: 50,
    height: 50,
    fill: "#26A69A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -5,
    width: 60,
    height: 10,
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -30,
    width: 10,
    height: 60,
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -5,
    cy: -5,
    r: 8,
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: -5,
    r: 8,
    fill: "#FF5252"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 60,
    r: 5,
    fill: "#FFD54F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 40,
    r: 3,
    fill: "#FF5252"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 70,
    r: 4,
    fill: "#7E57C2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 60,
    r: 5,
    fill: "#FFD54F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 40,
    r: 3,
    fill: "#FF5252"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 70,
    r: 4,
    fill: "#7E57C2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 150,
    r: 5,
    fill: "#26A69A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 130,
    r: 3,
    fill: "#FFD54F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 150,
    r: 5,
    fill: "#26A69A"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 130,
    r: 3,
    fill: "#FFD54F"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#26A69A",
    textAnchor: "middle"
  }, "WELCOME BONUS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#26A69A",
    textAnchor: "middle"
  }, "\u20B9500 OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#333",
    textAnchor: "middle"
  }, "Special discount for new customers. Thanks for joining us!")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBonus);
export default __webpack_public_path__ + "static/media/welcome_bonus.a6503d91375dcfe32a5016961c46e65a.svg";
export { ForwardRef as ReactComponent };